import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Observable, catchError, map, of } from 'rxjs';

import { LOG_MODULE, LoggerService } from '../logging';

import { I18nNamespaceService } from './i18n-namespace.service';

export const i18nGuard: CanActivateFn = (route): Observable<boolean> => {
  const namespaces: readonly string[] =
    (route.data['i18n'] as readonly string[] | undefined) ?? [];

  if (namespaces.length === 0) {
    return of(true);
  }
  const i18nService: I18nNamespaceService = inject(I18nNamespaceService);
  const logger: LoggerService = inject(LoggerService);

  return i18nService.ensureLoaded(namespaces).pipe(
    map(() => true),
    catchError((error: unknown) => {
      logger.error('Translation namespaces failed to load, navigating anyway', error, {
        module: LOG_MODULE.i18nGuard,
        namespaces: namespaces.join(','),
        path: route.routeConfig?.path ?? '',
      });
      return of(true);
    }),
  );
};
